import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-87f08790"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "dept-name-field"
};
const _hoisted_2 = {
  key: 0,
  class: "dept-name-prefix"
};
const _hoisted_3 = {
  class: "sales-prod-scope-option"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("与上级团队一致");

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sales-prod-scope-tip"
}, "创建子级团队后，可自动按上级团队商品范围销售", -1));

const _hoisted_6 = {
  class: "sales-prod-scope-option"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("自定义选择商品");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sales-prod-scope-tip"
}, "创建子级团队后，默认为空，需自行选择加入商品", -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确认");

import { computed, watch, ref } from 'vue';
import { getBusiAreeTree, addNextDeptInfo, editSaveDeptInfo } from '@/request';
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  name: 'AddChildTeamModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    actDept: {
      type: [null, Object],
      default: null
    },
    isEdit: {
      type: Boolean,
      defualt: false
    },

    /** 组织结构树根节点团队名称（一级团队 structureName） */
    rootStructureName: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const treeRef = ref();
    const form = ref({
      deptName: '',
      areaList: [],
      parentName: '',
      busiAreaName: '',
      areaLevel: '',
      salesProdScope: 1
    });
    const treeData = ref([]);
    const cascaderValue = ref([]);
    const cascaderSelectedList = ref([]);
    const areaLevels = [{
      label: '全国团队',
      value: 'country'
    }, {
      label: '大区团队',
      value: 'region'
    }, {
      label: '省级团队',
      value: 'province'
    }, {
      label: '市级团队',
      value: 'city'
    }, {
      label: '区县级团队',
      value: 'district'
    }];

    function getTree({
      busiArea,
      levelType,
      structureId
    }) {
      // 获取区域数据
      return getBusiAreeTree({
        supplierId: props.supplierId,
        parentAdcode: busiArea,
        areaLevl: levelType,
        structureId
      }).then(data => {
        if (data !== null && data !== void 0 && data.length) {
          treeData.value = data;
        }
      });
    }

    const loading = ref(false);
    watch(() => props.modelValue, newVal => {
      if (newVal && props.actDept) {
        if (!props.isEdit) {
          // 新增初始化
          const {
            text,
            busiAreaName,
            busiArea,
            levelType,
            areaLevel
          } = props.actDept.data;
          form.value = {
            deptName: '',
            areaList: [],
            parentName: text.replace(/\(\S+\)/, ''),
            busiAreaName,
            areaLevel: '',
            salesProdScope: 1
          };
          cascaderValue.value = [];
          getTree({
            busiArea,
            levelType
          });
        } else {
          // 编辑初始化
          const {
            text,
            busiAreaName,
            areaLevel
          } = props.actDept.parent.data;
          const deptBusi = props.actDept.data.busiArea;
          form.value.parentName = text;
          form.value.busiAreaName = busiAreaName;
          form.value.deptName = props.actDept.data.text.replace(/\(\S+\)/, '');
          form.value.areaList = deptBusi ? String(deptBusi).split(',') : [];
          form.value.areaLevel = props.actDept.data.areaLevel;
          form.value.salesProdScope = normalizeSalesProdScope(props.actDept.data.salesProdScope);
          loading.value = true; // console.log(props.actDept.data)

          getTree({
            busiArea: props.actDept.parent.data.busiArea,
            levelType: props.actDept.parent.data.levelType,
            structureId: props.actDept.data.id
          }).then(() => {
            setTimeout(() => {
              let list = [];

              if (deptBusi == null || deptBusi === '') {
                cascaderValue.value = list;
                loading.value = false;
                return;
              }

              const busi = String(deptBusi);
              treeData.value.forEach(province => {
                if (busi.includes(province.id)) {
                  if (province.children && province.children.length) {
                    province.children.forEach(city => {
                      if (city.children && city.children.length) {
                        city.children.forEach(area => {
                          list.push([province.id, city.id, area.id]);
                        });
                      } else {
                        list.push([province.id, city.id]);
                      }
                    });
                  } else {
                    list.push([province.id]);
                  }

                  return;
                }

                if (province.children && province.children.length) {
                  province.children.forEach(city => {
                    if (busi.includes(city.id)) {
                      if (city.children && city.children.length) {
                        city.children.forEach(area => {
                          list.push([province.id, city.id, area.id]);
                        });
                      } else {
                        list.push([province.id, city.id]);
                      }

                      return;
                    }

                    if (city.children && city.children.length) {
                      city.children.forEach(area => {
                        if (busi.includes(area.id)) {
                          list.push([province.id, city.id, area.id]);
                        }
                      });
                    }
                  });
                }
              });
              cascaderValue.value = list;
              loading.value = false;
            }, 500);
          });
        }
      }
    });

    function confirm() {
      var _cascaderValue$value;

      if (!((_cascaderValue$value = cascaderValue.value) !== null && _cascaderValue$value !== void 0 && _cascaderValue$value.length)) {
        ElMessage.warning('请选择团队业务区域');
        return;
      }

      cascaderChange();
      let areaList = formatCheckedKeys(treeData.value, []);
      let areaLevelList = Array.from(new Set(areaList.map(v => v.areaLevel)));
      /**  if (areaLevelList.length > 1) {
         ElMessage.error('业务区域等级不同')
         return
       }
       */

      let node = props.actDept.data;
      let parentNode = props.actDept.parent.data;
      let deptBusiAreaName = areaList.map(v => v.text).join(',');
      let deptBusiArea = areaList.map(v => v.id).join(',');

      if (!props.isEdit) {
        // 新增场景：显示确认弹框
        ElMessageBox.confirm('请确认团队名称是否正确，提交后不允许修改', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户确认后执行保存
          addNextDeptInfo({
            parentId: node.id,
            levelType: node.levelType,
            parentCode: node.structureCode,
            parentBusiArea: node.busiArea,
            deptBusiArea,
            deptName: form.value.deptName,
            deptBusiAreaName,
            areaLevel: form.value.areaLevel,
            salesProdScope: form.value.salesProdScope,
            __warn: true,
            __repeat: true
          }, {
            params: {
              supplierId: props.supplierId
            }
          }).then(data => {
            if (data.success) {
              ElMessage.success('添加成功!');
              emit('success');
              visible.value = false;
            }
          });
        }).catch(() => {// 用户点击取消，不执行任何操作
        });
      } else {
        // 编辑场景：直接保存
        editSaveDeptInfo({
          parentId1: parentNode.id,
          structureId1: node.id,
          structureCode1: node.structureCode,
          structureLevelType1: node.levelType,
          parentLevelType: parentNode.levelType,
          parentBusiArea1: parentNode.busiArea,
          deptBusiArea1: deptBusiArea,
          deptName1: form.value.deptName,
          deptBusiAreaName1: deptBusiAreaName,
          supplierId: props.supplierId,
          areaLevel: form.value.areaLevel,
          salesProdScope1: form.value.salesProdScope,
          __warn: true,
          __repeat: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('修改成功!');
            emit('success');
            visible.value = false;
          }
        });
      }
    }

    function normalizeSalesProdScope(val) {
      const n = Number(val);
      return n === 2 ? 2 : 1;
    }

    const cascaderProps = {
      label: 'text',
      value: 'id',
      emitPath: true,
      multiple: true,
      checkStrictly: false
    };

    function cascaderChange() {
      cascaderSelectedList.value = treeRef.value.getCheckedNodes().map(v => {
        return {
          id: v.value,
          text: v.data.text
        };
      }); // console.log('change', JSON.stringify(cascaderValue.value))
    }

    function formatCheckedKeys(treeList, targetList = []) {
      let checkedKeys = cascaderSelectedList.value;
      let list = [...targetList];
      treeList.forEach(item => {
        if (checkedKeys.find(v => v.id === item.id)) {
          list.push({
            id: item.id,
            text: item.text,
            areaLevel: item.areaLevel
          });
          return;
        }

        if (item.children && item.children.length) {
          list = list.concat(formatCheckedKeys(item.children));
        }
      });
      return list;
    }

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_cascader = _resolveComponent("el-cascader");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.isEdit ? '编辑' : '新增下级'
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          "label-width": "120px",
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "上级团队名称:"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(form.value.parentName), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上级团队区域:"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(form.value.busiAreaName), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "团队名称:",
            prop: "deptName",
            rules: {
              required: true,
              message: '请填写团队名称',
              trigger: 'submit'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.rootStructureName ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.rootStructureName) + "-", 1)) : _createCommentVNode("", true), _createVNode(_component_el_input, {
              modelValue: form.value.deptName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.deptName = $event),
              disabled: false,
              class: "dept-name-input",
              placeholder: "输入子级团队名称后缀（全称将为一级团队名称+后缀，建议以区域为后缀）"
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "团队业务区域:",
            prop: "areaList",
            rules: {
              required: true,
              message: '请选择团队业务区域',
              trigger: 'submit'
            }
          }, {
            default: _withCtx(() => [!loading.value ? (_openBlock(), _createBlock(_component_el_cascader, {
              key: 0,
              style: {
                "width": "100%"
              },
              modelValue: cascaderValue.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => cascaderValue.value = $event),
              options: treeData.value,
              showAllLevels: true,
              "collapse-tags": "",
              ref_key: "treeRef",
              ref: treeRef,
              props: cascaderProps
            }, null, 8, ["modelValue", "options"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "团队级别",
            prop: "areaLevel",
            rules: {
              required: true,
              message: '请选择团队级别'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.areaLevel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.areaLevel = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(areaLevels, item => {
                return _createVNode(_component_el_option, {
                  label: item.label,
                  value: item.value,
                  key: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "可售商品",
            prop: "salesProdScope",
            rules: {
              required: true,
              message: '请选择可售商品范围'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.salesProdScope,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.salesProdScope = $event),
              class: "sales-prod-scope-group"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_4]),
                _: 1
              }), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
              }), _hoisted_8])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};